var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_setup.showButton && _setup.isValidError)?_c('i',{directives:[{name:"b-tooltip",rawName:"v-b-tooltip",value:(_vm.$t('chatBot.explainErrorButtonLabel')),expression:"$t('chatBot.explainErrorButtonLabel')"}],staticClass:"fa-kit fa-light-lightbulb-sparkle ml-2",on:{"click":_setup.handleExplainError}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }